// 先要安装: 专业级状态管理库Pinia
// https://pinia.vuejs.org/core-concepts/outside-component-usage.html
// npm install -g npm@11.7.0
// npm install pinia
import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
  state: () => ({
    count: 0,
    id: 0,
    invite: 0, // 推荐人的UUID
    user: null,
    // 当前用户帐号的登录状态
    login: false,
    isAgent: false,
    data: null
  }),
  actions: {
    increment() {
      this.count++
    },
    setUser(user) {
      this.user = user
    },
    // 设置登录状态
    setLogin(status) {
        this.login = status
        // console.log(`设置登录状态 ${this.login}`)
    },
    // 设置是否是代理（统一存布尔，并同步 localStorage 以便刷新恢复）
    setIsAgent(status) {
        const normalized = !!status && status !== '0' && status !== 0 && status !== 'false'
        this.isAgent = normalized
        localStorage.setItem('isAgent', normalized ? '1' : '0')
    },
    // 设置登录状态
    setData(data) {
        this.data = data
    },
    setId(id) {
      this.id = id
    },
    setInvite(invite) {
      this.invite = invite
    },
  }
})